<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">轮播列表</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="列表名称" prop="Title">
            <el-input v-model="Title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="createGroup">创建分组</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="handleSelectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column prop="videoGroupName" label="名称"></el-table-column>
              <!-- <el-table-column label="摄像头数量">
                <template slot-scope="scope">{{ scope.row.equipmentList.length }}</template>
              </el-table-column> -->
              <el-table-column fixed="right" label="操作" width="160">
                <template slot-scope="scope">
                  <!-- <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button> -->
                  <el-button @click="editClick(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    style="color:red;"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <!-- 树形节点弹窗 -->
    <div class="treeBox" v-if="showTree">
      <p class="treeTittle">{{ this.GroupId ? "编辑分组": "创建分组" }}</p>
      <el-form class="zj-search-form2" ref="form2" :label-width="labelWidth" @submit.native.prevent>
        <el-form-item label="名称" style="width:100%;font-size:16px;">
          <el-input v-model="addGroupName" placeholder="请输入名称" style="width:70%;font-size:14px;"></el-input>
        </el-form-item>
      </el-form>
      <img class="treeClose" src="../../../../../../assets/close.png" alt @click="changeShowTree" />
      <div class="treeOutLine">
        <el-tree
          style="height:100%;"
          v-loading="loading"
          show-checkbox
          check-on-click-node
          :element-loading-text="loadingText"
          :data="nodes"
          node-key="monitorId"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :default-checked-keys="defaultArr"
          :default-expanded-keys="['']"
          default-expand-all
          class="zj-demo-player-tree-device-tree"
          ref="tree"
        ></el-tree>
      </div>
      <el-botton class="addBtn" @click="addGroup">{{ this.GroupId ? "编辑分组": "新增分组" }}</el-botton>
    </div>
  </div>
</template>

<script>
import { getVideoGroup, videoListTree, getVideoGroupDetail, saveVideoGroup, delVideoGroup } from "@/api/src/videoApiGb"
export default {
  action: "swiperVideoList",
  controller: "UI",
  name: "swiperVideoList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      nodes: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      Title: "",
      showTree: false,
      loading: false,
      loadingText: "加载中...",
      // checkedArr:[],
      defaultArr: [],
      addGroupName: "",
      GroupId: "",
      selectData: [],
      equCode:null,
    };
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  },
  created: function() {},
  mounted: function() {
    this.search();
    this.getRegionTree();
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    addGroup() {
      if (this.addGroupName == "") {
        this.errmsg("名称不能为空！");
        return;
      }
      let checkedAllArr = '';
      let nodeData = this.$refs.tree.getCheckedNodes();
      console.log(nodeData)
      if(nodeData.length <= 0){
        this.errmsg("请至少选择一个设备");
        return;
      }
      nodeData.forEach((item,index) => {
        if (item.children.length == 0) {
          const separate = index == nodeData.length-1? '':','
          checkedAllArr += item.monitorId+separate;
        }
      });
      console.log(checkedAllArr,'0000000000000000000000000000')
        let params = {
          videoGroupName:this.addGroupName,
          ids:checkedAllArr
        }
        if(this.GroupId){
          params.id = this.GroupId
        }
        saveVideoGroup(params).then(res=>{
       
          this.changeShowTree();
          this.search();
          this.addGroupName = "";
        });
    },
    changeShowTree() {
      this.showTree = !this.showTree;
    },
    createGroup() {
      this.GroupId = "";
      this.addGroupName = "";
      this.defaultArr = [];
      this.showTree = !this.showTree;
    },
    getRegionTree() {
      videoListTree({}).then(
          (response) => {
            if (response.data) {
              let data = new Array(response.data)
              this.nodes = this.getVideoList(data)
            }
          }
        );
    },
    getVideoList(videoListTree){
          for (let i = 0; i < videoListTree.length; i++) {
            let item = videoListTree[i]
            item.leaf = false
            if(item.children && item.children.length){
              videoListTree[i].children = this.getVideoList(item.children)
            }else{
              item.leaf = true
            }
            if (!item.data) continue;
            let monitorId = null
            if(item.data.protocol == 'gb28181' && item.data.channelId ){
              monitorId = item.data.protocol + '-' + item.data.channelId
            }else if(item.data.protocol != 'gb28181' && item.data.id ){
              monitorId = item.data.protocol + '-' + item.data.id
            }
            videoListTree[i] = {
              children: item.children,
              anchor: item.anchor,
              data: null,
              ...item.data,
              isShowVideo:false,
              monitorId,
              leaf:item.leaf
            }
      }
      return videoListTree
    },
    search() {
      let searchInfo = {
        videoGroupName: this.Title,
        size: this.pageSize,
        page: this.currentPage
      };
      getVideoGroup(searchInfo).then(res=>{
        if(res.code == 0){
          this.tableData = res.data || [];
          this.total = res.count;
        }
      });
    },
    clearsearch() {
      this.Title = "";
      this.search();
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //编辑按钮
    editClick(index, row) {
      this.changeShowTree();
      this.editData = row;
      this.addGroupName = row.videoGroupName;
      this.GroupId = row.id;
      getVideoGroupDetail({"page":1,"size":999,"videoGroupName":row.videoGroupName}).then(res =>{
        if(res.code == 0 && res.data && res.data.length){
          this.defaultArr = res.data
          this.$refs.tree && this.$refs.tree.setCheckedNodes(res.data);
        }
      })
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
            const selectData = this.selectData;
            selectData.forEach((item,index)=>{
              delVideoGroup({videoGroupName: item.videoGroupName}).then(res=>{
                if(res.code == 0 ){
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                  // 清除 所有勾选项
                  // this.$refs.multipleTable.toggleRowSelection(item,false);
                  this.search();
                }else{
                  this.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
            });
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, {videoGroupName}) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          delVideoGroup({ videoGroupName }).then(res=>{
            if(res.code == 0 ){
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }else{
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
            this.search();
          })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  }
};
</script>

<style scoped>
.treeBox {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 500px;
  overflow: auto;
  background: #003566;
  border: 1px solid #00bcfe;
  padding: 5px 20px 20px;
  margin-left: -220px;
  margin-top: -260px;
}
.treeTittle {
  font-size: 20px;
  color: #ffffff;
}
.treeClose {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 15px;
}
.treeOutLine {
  width: 100%;
  height: 70%;
  overflow: auto;
}
.addBtn {
  display: block;
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  border-radius: 10px;
  background: #2ac1ff;
  cursor: pointer;
}
</style>